<template>
  <div>
    <navbar-component></navbar-component>
    <main>
      <page-header title="TPO: Major Recruiters"
                   :links="[{title:'Home', url:'/'},{title:'TPO', url: ''}, {title: 'Major Recruiters'}]"></page-header>
      <div class="container-2">
        <section class="sidebar">
          <sidebar :active="7"></sidebar>
        </section>
        <section class="content">
          <div class="heading-black1">Major Recruiters</div>
          <div class="grid md:grid-cols-2 lg:grid-cols-3 gap-y-5 gap-x-8 mx-4">
            <div class="shadow-md" v-for="img in 2" :key="img">
              <a :href="`/static/images/tpo/recruiters/${img}.jpg`" target="_blank">
                <img :src="`/static/images/tpo/recruiters/${img}.jpg`"
                     alt="image"
                     class="w-full object-cover transform hover:scale-105 transition duration-500 ease-in-out">
              </a>
            </div>
          </div>
        </section>
      </div>
      <key-recruiters></key-recruiters>
    </main>
    <footer-component></footer-component>
  </div>
</template>
<script>
import NavbarComponent from "@/components/Navbar.vue";
import FooterComponent from "@/components/Footer.vue";
import PageHeader from "@/components/PageHeader";
import Sidebar from "@/views/tpo/Sidebar";
import KeyRecruiters from "@/components/KeyRecruiters";

export default {
  name: "MajorRecruiters",
  components: {
    NavbarComponent,
    PageHeader,
    Sidebar,
    FooterComponent,
    KeyRecruiters,
  },
}
</script>
<style lang="scss" scoped/>
